import { Drawer } from '@mui/material';
import { FC } from 'react';
import { TableRoofFilterDrawerHead } from './head';

type Props = {
  open: boolean;
  closeDrawer: () => void;
  renderFilter: (closeDrawer: () => void) => JSX.Element;
};

export type TableRoofFilterDrawerProps = Props;

export const TableRoofFilterDrawer: FC<Props> = ({ open, closeDrawer, renderFilter }) => {
  return (
    <Drawer
      open={open}
      onClose={closeDrawer}
      anchor="right"
      sx={{
        '& .MuiDrawer-paper': {
          padding: '15px',
          boxSizing: 'border-box',
          width: {
            sm: '370px',
            xs: '100%'
          }
        }
      }}
    >
      <TableRoofFilterDrawerHead onClose={closeDrawer} />
      {renderFilter(closeDrawer)}
    </Drawer>
  );
};
